import { apiUserSendDetails } from '~constants/api';

import { post } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

import { typePrefix as prefix } from '~care-workers/actions';

export const typePrefix = `${prefix}-Send-details`;

const config = [{ actionType: 'sendDetails', apiPath: apiUserSendDetails, method: post }];

export const { sendDetails } = createThunks(typePrefix, config);
